// Lazy-loaded rrule utilities to reduce main bundle size
let rruleModule = null;

export const loadRRule = async () => {
  if (!rruleModule) {
    rruleModule = await import('rrule');
  }
  return rruleModule;
};
